import React, { useState } from 'react';
import { Space, Popover } from 'antd';
import DefaultLandingPrompt from '@components/common/DefaultLandingPage';
import RemoveDashboardPopup from '@components/common/Dashboard/RemoveDashboardPopup';
import { MarginLayout, SectionWrapper, ContentWrapper } from './styled';
import { ToggleButton } from '@src/components/common/Utils/Buttons';
import ToggleIcon from '@icons/common/toggle.svg';
import Actions from './Actions';

const Content = ({ currentShareId, pageType }) => {
  return (
    <ContentWrapper>
      <SectionWrapper>
        <div>
          <Actions currentShareId={currentShareId} pageType={pageType} />
        </div>
      </SectionWrapper>
    </ContentWrapper>
  );
};

// eslint-disable-next-line react/display-name
export default ({ currentShareId, pageType }) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    <React.Fragment>
      <MarginLayout>
        <Space wrap>
          <Popover
            content={<Content currentShareId={currentShareId} pageType={pageType} />}
            title=""
            trigger="click"
            placement="bottomRight"
            styles={{ body: { paddingLeft: 20 } }}
            zIndex={900}
            getPopupContainer={(trigger) => (trigger.parentNode as HTMLElement) || document.body}
            open={open}
            onOpenChange={handleOpenChange}
          >
            <ToggleButton icon={<ToggleIcon />} />
          </Popover>
        </Space>
      </MarginLayout>
      <DefaultLandingPrompt />
      <RemoveDashboardPopup id={currentShareId} />
    </React.Fragment>
  );
};
